module.exports = __webpack_public_path__ + "img/4.bf089df2.svg";